import { useMemo } from 'react';
import { usePolling } from './use-polling';
import type { QueryResult } from './use-polling';
import type { PaymentAction, PaymentState } from '../context';

function handleAssertionResult(
  result: QueryResult,
  dispatch: (action: PaymentAction) => void
): boolean {
  if (result.status === 'SUCCESS' && result.assertion_options) {
    dispatch({
      type: 'ASSERTION_OPTIONS_RECEIVED',
      assertionOptions: result.assertion_options,
      redirectUrlAfterPayment: result.redirect_url_after_payment ?? null,
    });
    return true;
  }

  if (result.status === 'SUCCESS' && !result.assertion_options) {
    dispatch({ type: 'SET_ERROR', errorMessage: 'Erro ao consultar pagamento.' });
    return true;
  }

  if (result.status === 'ERROR') {
    dispatch({ type: 'SET_ERROR', errorMessage: result.status_message || 'Erro ao consultar pagamento.' });
    return true;
  }

  return false;
}

export function useAssertionOptions(): void {
  const config = useMemo(() => ({
    activeState: 'LOADING' as PaymentState,
    onResult: handleAssertionResult,
    timeoutMessage: 'Tempo limite atingido. Tente novamente.',
  }), []);

  usePolling(config);
}
